module.exports = __webpack_public_path__ + "img/webdev.c94cfc50.svg";